export default __webpack_public_path__ + "76de34821749d65d97ce4365d76885e0.png";